import React from 'react';
import { Row } from '@paypalcorp/pp-react-grid';
import { Button } from '@paypalcorp/pp-react-buttons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getLocaleMessages from '../../utils/localesMessages';

const { cancelButton, back, continueButton, finishButton } =
  getLocaleMessages('buttonsV3/common');

const WizardNavButtons = ({
  steps: { currentStep, totalSteps },
  showSpinner = false,
  handleBack,
  handleSubmit,
}) => {
  return (
    <Row className="wizard-navigator-buttons">
      <Button className="back" secondary onClick={handleBack}>
        {currentStep === 1 ? cancelButton : back}
      </Button>
      <Button
        className="next"
        type="submit"
        onClick={handleSubmit}
        btnState={showSpinner ? 'processing' : 'initial'}
      >
        {currentStep === totalSteps ? finishButton : continueButton}
      </Button>
    </Row>
  );
};

WizardNavButtons.propTypes = {
  steps: PropTypes.object,
  showSpinner: PropTypes.bool,
  handleBack: PropTypes.func,
  handleSubmit: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { buttonFactoryV3: { currentStep, totalSteps } = {} } = state;

  return {
    steps: {
      currentStep,
      totalSteps,
    },
  };
};

export default connect(mapStateToProps)(WizardNavButtons);
